import { type Ref, ref, watch } from 'vue'

import { useDebounceFn } from '@vueuse/core'

import { IS_TYPING_DEBOUNCE_TIME } from '../../SearchBar.constants'

export function useIsTyping(query: Ref<string>) {
  const isTyping = ref(false)
  if (import.meta.client) {
    const stopTyping = useDebounceFn(() => {
      isTyping.value = false
    }, IS_TYPING_DEBOUNCE_TIME)

    const startTyping = () => {
      isTyping.value = true
      stopTyping()
    }

    watch(query, async () => {
      if (query.value.length) {
        startTyping()
      }
    })
  }

  return {
    isTyping,
  }
}
